import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  BodyLarge,
  TitleMedium,
  ButtonTextMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  Table,
  BasicSingleCell,
} from '@spaced-out/ui-design-system/lib/components/Table';
import {
  CONSTANTS,
  getTranslatedText,
} from 'src/components/authentication/contants';
import {selectValidAgencies} from 'src/selectors/authentication';
import {mockSignIn} from 'src/action-creators/authentication';

import type {dynamicAgencyProps} from 'src/types/authentication';

import css from './dynamic-agency.css';
import maincss from 'src/components/authentication/main.css';


const DynamicAgency = (props: dynamicAgencyProps) => {
  const {t} = useLabelTranslation();
  const {creds} = props;
  const dispatch = useDispatch();
  const validAgencies = useSelector(selectValidAgencies);
  // @ts-expect-error - TS2339 - Property 'env' does not exist on type 'DefaultRootState'.
  const {_a, _b, hostname} = useSelector((state) => state.env);

  const handleSignInClicked = (agency: any) => {
    const host = hostname.split('.').slice(1).join('.');
    dispatch(mockSignIn(creds.email, creds.password, host, agency.slug));
  };

  // @ts-expect-error - TS18049 - 'validAgencies' is possibly 'null' or 'undefined'.
  const agencyRow = validAgencies.map((agency) => {
    return {
      Agency: agency.name,
      Action: (
        <ButtonTextMedium
          color="clickable"
          className={css.signInBtn}
          // @ts-expect-error - TS2769 - No overload matches this call.
          onClick={() => handleSignInClicked(agency)}
        >
          {t('Sign_In', 'Sign In')}
        </ButtonTextMedium>
      ),
      id: agency.name,
    };
  });

  const headers = [
    {
      key: 'Agency',
      label: t('Agency', 'Agency'),
    },
    {
      key: 'Action',
      label: t('Action', 'Action'),
      // @ts-expect-error - TS7006 - Parameter 'row' implicitly has an 'any' type.
      render: (row) => <BasicSingleCell> {row.data.Action} </BasicSingleCell>,
    },
  ];

  return (
    <div className={css.dynamicAgencyPage}>
      <TitleMedium className={css.titleText}>
        {getTranslatedText(t, CONSTANTS.DYNAMIC_AGENCY_TITLE)}
      </TitleMedium>
      <BodyLarge className={maincss.subText}>
        {getTranslatedText(t, CONSTANTS.DYNAMIC_AGENCY_SUBTEXT)}
      </BodyLarge>
      <div className={css.agencyTable}>
        {/* @ts-expect-error - TS2322 - Type '({ key: string; label: string; render?: undefined; } | { key: string; label: string; render: (row: any) => Element; })[]' is not assignable to type 'GenericHeaderItems<{ Agency: string; Action: Element; id: string; }, GenericObject>'. */}
        <Table entries={agencyRow} headers={headers} />
      </div>
    </div>
  );
};

export default DynamicAgency;
